import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import { useUserDataStore } from "@/stores/userData.js";
import { useEventsStore } from "@/stores/events.js";
import { useOwnedGamesStore } from "@/stores/ownedGamesStore.js";

const pinia = createPinia()
const app = createApp(App);
app.use(pinia);

await useUserDataStore().init();
await useEventsStore().init();
await useOwnedGamesStore().init();

app.use(router);
app.mount("#app");
